module.exports = __webpack_public_path__ + "img/gettitle.e018fda7.png";